import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConversationDetailsComponent } from '../conversation-details/conversation-details.component';

import { InboxComponent } from './inbox.component';

const routes: Routes = [
  {
    path: '',
    component: InboxComponent,
    children: [
      {
        path: 'view/:conversationId',
        component: ConversationDetailsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InboxRoutingModule {}
